export const JUMPLIST = [
    { label: '首页', value: 'yinseinner://to_index'},
    { label: '社区广场', value: 'yinseinner://to_community'},
    { label: '会员中心', value: 'yinseinner://vip_page'},
    { label: '金币充值', value: 'yinseinner://vip_coin'},
    { label: '账号凭据', value: 'yinseinner://account_code'},
    { label: '签到福利', value: 'yinseinner://sign_page'},
    { label: '短视频（抖阴）', value: 'yinseinner://short_video'},
    { label: '套图', value: 'yinseinner://video_image'},
    { label: '抽奖活动', value: 'yinseinner://cj_activity'},
    { label: '帖子详情页', value: 'yinseinner://postdetail/帖子ID'},
    { label: '板块详情', value: 'yinseinner://moduledetail/模块ID'},
    { label: '播放详情', value: 'yinseinner://playdetail/视频ID'},
    { label: '分享推广', value: 'yinseinner://share_tg'},
    { label: '积分福利', value: 'yinseinner://jf_fuli'},
    { label: '应用中心', value: 'yinseinner://yy_center'},
    { label: '安卓版本', value: 'yinseinner://version'},
    { label: 'H5外部链接', value: 'http/https开头'},
    { label: '视频排行榜', value: 'yinseinner://video_rank'},
    { label: '黄游', value: 'yinseinner://huangyou'},
]
